module.exports = __webpack_public_path__ + "static/masthead_bg_mobile-513e6dfdcd54a0062f449e71408bdffd.png";